import { useCropModalContext } from '../context/crop-modal-context'
import { useHarvestFrostWarning } from '../hooks/use-harvest-frost-warning'
import { TpBanner } from '~/components'

export const CropWarningBanner = ({ previewScheduleData, frostDates }) => {
  const { lifecycleType, successions, growthType, isCustomCrop } = useCropModalContext()
  const warning = useHarvestFrostWarning({ previewScheduleData, frostDates, successions, growthType })

  if (isCustomCrop) {
    return (
      <TpBanner
        severity="info"
        message="Custom crops don't support crop-to-crop relationships, but family-to-family relationships still apply."
      />
    )
  }

  if (lifecycleType === 'perennial' || !warning) return null

  return <TpBanner severity={warning.severity} message={warning.message} />
}
